import React from 'react';
import {
    faCheckCircle,
    faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';
import { Button } from './button';

export const ConfirmModal = ({
    modalText,
    onConfirm,
    onCancel,
    cancelText,
    confirmText,
    confirmIcon,
    cancelIcon,
    // Confirm is the primary/affirmative action, so it defaults to the brand
    // blue color; Cancel defaults to the alert (red) color. If a specific usage
    // needs the inverse (e.g. a destructive confirm should read red), override
    // confirmType/cancelType explicitly at that call site.
    confirmType = 'success',
    cancelType = 'danger',
}) => {
    return (
        <div className='absolute'>
            <div className='w-full fixed top-0 left-0 h-full flex justify-center items-center bg-backgrounds-black bg-opacity-20 z-50 border rounded-xl backdrop-filter backdrop-blur-sm'>
                <div className='sm:w-auto md:w-auto lg:w-auto xl:w-auto relative bg-backgrounds-slate p-4 rounded-xl shadow-lg flex-col items-center border sm:mx-2 sm:max-w-full md:max-w-full lg:max-w-lg'>
                    <div className='w-full flex items-center justify-start w-full mb-4 p-4 border rounded-xl bg-backgrounds-white h-auto'>
                        <div className='text-xl font-semibold text-texts-tertiary break-words max-w-full'>
                            {modalText}
                        </div>
                    </div>

                    <div className='flex items-center justify-between w-full min-w-[300px]'>
                        <Button
                            // Solid, visible-at-rest colors (not just on hover) so a
                            // first-time user can tell the choices apart without
                            // needing to read the labels.
                            className={`min-w-[120px] ${
                                cancelType === 'danger'
                                    ? '!bg-buttons-alert400 !border-buttons-alert400 !text-backgrounds-white'
                                    : ''
                            }`}
                            type={cancelType}
                            onClick={() => {
                                onCancel();
                            }}
                            icon={cancelIcon ?? faCircleXmark}
                            text={cancelText ?? 'Cancel'}
                            hoverText={'Cancel the above action'}
                        />
                        <Button
                            className={`min-w-[120px] ${
                                confirmType === 'success'
                                    ? '!bg-backgrounds-primary100 !border-backgrounds-primary200 !text-texts-tertiary'
                                    : ''
                            }`}
                            type={confirmType}
                            onClick={() => {
                                onConfirm();
                            }}
                            icon={confirmIcon ?? faCheckCircle}
                            text={confirmText ?? 'Confirm'}
                            hoverText={'Accept the above action'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
